// Copyright (c) Move Closer 2022.

import { Headers, IResponse } from '@movecloser/front-core'
import { MutationOptions as Mutation, QueryOptions as Query } from '@apollo/client'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const GraphQLDriverType = Symbol.for('IGraphQLDriver')

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface GraphQLConfig {
  baseURL: string
  headers: Headers
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface IGraphQLDriver {
  query (query: QueryOptions, headers: Headers): Promise<IResponse>
  mutate (mutation: MutationOptions, headers: Headers): Promise<IResponse>
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export type MutationOptions = Mutation

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export type QueryOptions = Query
